export const ExplainabilityStatuses = {
    MANUAL_UNRESOLVED: 1,
    MANUAL_RESOLVED: 2,
    UNEXPLAINABLE_UNRESOLVED: 3,
    UNEXPLAINABLE_RESOLVED: 4, // deprecated
}
